import './LitJewelleryDetail.svelte.css';
/* src/LitJewelleryDetail.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	svg_element,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import Images from './components/JewelleryDetail/JewelleryDetailImages.svelte.js';
import SizeList from './components/JewelleryDetail/JewelleryDetailSizeList.svelte.js';
import Customize from './components/JewelleryDetail/JewelleryDetailCustomize.svelte.js';
import CartIn from './components/JewelleryDetail/JewelleryDetailCartIn.svelte.js';

function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = " ";
			attr(div, "class", "jewellery-empty");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (75:36) 
function create_if_block_4(ctx) {
	let customize;
	let current;

	customize = new Customize({
			props: { jewellery: /*jewellery*/ ctx[0] }
		});

	return {
		c() {
			create_component(customize.$$.fragment);
		},
		m(target, anchor) {
			mount_component(customize, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const customize_changes = {};
			if (dirty & /*jewellery*/ 1) customize_changes.jewellery = /*jewellery*/ ctx[0];
			customize.$set(customize_changes);
		},
		i(local) {
			if (current) return;
			transition_in(customize.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(customize.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(customize, detaching);
		}
	};
}

// (73:1) {#if '1' === jewellery.typeID}
function create_if_block_3(ctx) {
	let sizelist;
	let current;

	sizelist = new SizeList({
			props: { jewellery: /*jewellery*/ ctx[0] }
		});

	return {
		c() {
			create_component(sizelist.$$.fragment);
		},
		m(target, anchor) {
			mount_component(sizelist, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const sizelist_changes = {};
			if (dirty & /*jewellery*/ 1) sizelist_changes.jewellery = /*jewellery*/ ctx[0];
			sizelist.$set(sizelist_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sizelist.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sizelist.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sizelist, detaching);
		}
	};
}

// (86:2) {#if jewellery.contents.length > 1}
function create_if_block(ctx) {
	let div;
	let t;
	let if_block0 = 0 < /*contentsPageNum*/ ctx[1] && create_if_block_2(ctx);
	let if_block1 = /*jewellery*/ ctx[0].contents.length - 1 > /*contentsPageNum*/ ctx[1] && create_if_block_1(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "jewellery-contents-ctrl svelte-1gwxeom");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t);
			if (if_block1) if_block1.m(div, null);
		},
		p(ctx, dirty) {
			if (0 < /*contentsPageNum*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(div, t);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*jewellery*/ ctx[0].contents.length - 1 > /*contentsPageNum*/ ctx[1]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

// (88:4) {#if 0 < contentsPageNum}
function create_if_block_2(ctx) {
	let span;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			span = element("span");
			button = element("button");
			button.textContent = "←前へ";
			attr(button, "class", "svelte-1gwxeom");
			attr(span, "class", "prev svelte-1gwxeom");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, button);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[6]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

// (97:4) {#if jewellery.contents.length - 1 > contentsPageNum}
function create_if_block_1(ctx) {
	let span;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			span = element("span");
			button = element("button");
			button.textContent = "次へ→";
			attr(button, "class", "svelte-1gwxeom");
			attr(span, "class", "next svelte-1gwxeom");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, button);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler_1*/ ctx[7]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let link;
	let t0;
	let div3;
	let h1;
	let t1_value = /*jewellery*/ ctx[0].arrangeName + "";
	let t1;
	let t2;
	let ruby;
	let rb;
	let t3_value = /*jewellery*/ ctx[0].arrangeName2 + "";
	let t3;
	let t4;
	let rp0;
	let t6;
	let rt;
	let t7_value = /*jewellery*/ ctx[0].ruby + "";
	let t7;
	let t8;
	let rp1;
	let t10;
	let t11_value = /*jewellery*/ ctx[0].designName + "";
	let t11;
	let t12;
	let t13_value = /*jewellery*/ ctx[0].typeName + "";
	let t13;
	let t14;
	let p0;
	let t15_value = /*jewellery*/ ctx[0].explanation + "";
	let t15;
	let t16;
	let images;
	let t17;
	let current_block_type_index;
	let if_block0;
	let t18;
	let div0;
	let h2;
	let t19_value = /*jewellery*/ ctx[0].postTitle + "";
	let t19;
	let t20;
	let p1;
	let t21_value = /*jewellery*/ ctx[0].contents[/*contentsPageNum*/ ctx[1]] + "";
	let t21;
	let t22;
	let t23;
	let div1;
	let h30;
	let img0;
	let img0_src_value;
	let img0_alt_value;
	let t24;
	let p2;
	let t26;
	let a;
	let t27;
	let t28_value = /*jewellery*/ ctx[0].typeName + "";
	let t28;
	let t29;
	let svg;
	let path;
	let a_href_value;
	let div1_class_value;
	let t30;
	let cartin;
	let t31;
	let div2;
	let h31;
	let img1;
	let img1_src_value;
	let t32;
	let table;
	let tr0;
	let th0;
	let td0;
	let t34_value = /*jewellery*/ ctx[0].postTitle + "";
	let t34;
	let t35;
	let tr1;
	let th1;
	let td1;
	let t37_value = /*jewellery*/ ctx[0].code + "";
	let t37;
	let t38;
	let tr2;
	let th2;
	let td2;
	let t40_value = /*jewellery*/ ctx[0].arrangeName + "";
	let t40;
	let t41;
	let tr3;
	let th3;
	let td3;
	let t43_value = /*jewellery*/ ctx[0].designName + "";
	let t43;
	let t44;
	let current;

	images = new Images({
			props: { jewellery: /*jewellery*/ ctx[0] }
		});

	const if_block_creators = [create_if_block_3, create_if_block_4, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if ('1' === /*jewellery*/ ctx[0].typeID) return 0;
		if ('4' === /*jewellery*/ ctx[0].typeID) return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*jewellery*/ ctx[0].contents.length > 1 && create_if_block(ctx);

	cartin = new CartIn({
			props: { jewellery: /*jewellery*/ ctx[0] }
		});

	return {
		c() {
			link = element("link");
			t0 = space();
			div3 = element("div");
			h1 = element("h1");
			t1 = text(t1_value);
			t2 = space();
			ruby = element("ruby");
			rb = element("rb");
			t3 = text(t3_value);
			t4 = space();
			rp0 = element("rp");
			rp0.textContent = "《";
			t6 = space();
			rt = element("rt");
			t7 = text(t7_value);
			t8 = space();
			rp1 = element("rp");
			rp1.textContent = "》";
			t10 = space();
			t11 = text(t11_value);
			t12 = space();
			t13 = text(t13_value);
			t14 = space();
			p0 = element("p");
			t15 = text(t15_value);
			t16 = space();
			create_component(images.$$.fragment);
			t17 = space();
			if_block0.c();
			t18 = space();
			div0 = element("div");
			h2 = element("h2");
			t19 = text(t19_value);
			t20 = space();
			p1 = element("p");
			t21 = text(t21_value);
			t22 = space();
			if (if_block1) if_block1.c();
			t23 = space();
			div1 = element("div");
			h30 = element("h3");
			img0 = element("img");
			t24 = space();
			p2 = element("p");
			p2.textContent = "パワーストーンの数・種類・配置が簡単に変更できます。";
			t26 = space();
			a = element("a");
			t27 = text("この");
			t28 = text(t28_value);
			t29 = text("をカスタマイズする\n\t\t\t");
			svg = svg_element("svg");
			path = svg_element("path");
			t30 = space();
			create_component(cartin.$$.fragment);
			t31 = space();
			div2 = element("div");
			h31 = element("h3");
			img1 = element("img");
			t32 = space();
			table = element("table");
			tr0 = element("tr");
			th0 = element("th");
			th0.textContent = "商品名";
			td0 = element("td");
			t34 = text(t34_value);
			t35 = space();
			tr1 = element("tr");
			th1 = element("th");
			th1.textContent = "商品番号";
			td1 = element("td");
			t37 = text(t37_value);
			t38 = space();
			tr2 = element("tr");
			th2 = element("th");
			th2.textContent = "パワーストーン";
			td2 = element("td");
			t40 = text(t40_value);
			t41 = space();
			tr3 = element("tr");
			th3 = element("th");
			th3.textContent = "デザイン";
			td3 = element("td");
			t43 = text(t43_value);
			t44 = text("デザイン");
			attr(link, "rel", "preload");
			attr(link, "as", "style");
			attr(link, "onload", "this.onload=null;this.rel='stylesheet'");
			attr(link, "href", "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;900&display=swap");
			attr(rb, "class", "rb");
			attr(rp0, "class", "rp");
			attr(rt, "class", "rt svelte-1gwxeom");
			attr(rp1, "class", "rp");
			attr(ruby, "class", "ruby");
			attr(h1, "class", "svelte-1gwxeom");
			attr(p0, "class", "jewellery-explanation svelte-1gwxeom");
			attr(h2, "class", "svelte-1gwxeom");
			attr(p1, "class", "svelte-1gwxeom");
			attr(div0, "class", "jewellery-contents svelte-1gwxeom");
			if (!src_url_equal(img0.src, img0_src_value = /*getBtoTitle*/ ctx[2](/*jewellery*/ ctx[0].assetsUrl, /*jewellery*/ ctx[0].typeID))) attr(img0, "src", img0_src_value);
			attr(img0, "width", "363");
			attr(img0, "height", "15");
			attr(img0, "alt", img0_alt_value = "この" + /*jewellery*/ ctx[0].typeName + "を、あなたの願いにあわせてカスタマイズできます。");
			attr(img0, "loading", "lazy");
			attr(h30, "class", "svelte-1gwxeom");
			attr(p2, "class", "svelte-1gwxeom");
			attr(path, "d", "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z");
			attr(svg, "viewBox", "0 0 24 24");
			attr(a, "href", a_href_value = /*jewellery*/ ctx[0].btoUrl);
			attr(a, "class", "lit-flat-button flat-brown svelte-1gwxeom");
			attr(div1, "class", div1_class_value = "jewellery-to-ordermade page-type-" + /*jewellery*/ ctx[0].typeID + " svelte-1gwxeom");
			set_style(div1, "background-image", "url(" + /*getCustomizeBG*/ ctx[3](/*jewellery*/ ctx[0].assetsUrl, /*jewellery*/ ctx[0].typeID) + ")");
			if (!src_url_equal(img1.src, img1_src_value = /*specTitle*/ ctx[4])) attr(img1, "src", img1_src_value);
			attr(img1, "width", "109");
			attr(img1, "height", "15");
			attr(img1, "alt", "アクセサリーの仕様");
			attr(img1, "loading", "lazy");
			attr(th0, "class", "svelte-1gwxeom");
			attr(td0, "class", "svelte-1gwxeom");
			attr(th1, "class", "svelte-1gwxeom");
			attr(td1, "class", "svelte-1gwxeom");
			attr(th2, "class", "svelte-1gwxeom");
			attr(td2, "class", "svelte-1gwxeom");
			attr(th3, "class", "svelte-1gwxeom");
			attr(td3, "class", "svelte-1gwxeom");
			attr(table, "cellspacing", "0");
			attr(table, "summary", "item_spec_list");
			attr(table, "class", "svelte-1gwxeom");
			attr(div2, "class", "jewellery-spec svelte-1gwxeom");
			attr(div3, "class", "lit-jewellery svelte-1gwxeom");
			set_style(div3, "background", "url(" + /*componentBG*/ ctx[5] + ") left top repeat");
		},
		m(target, anchor) {
			append(document.head, link);
			insert(target, t0, anchor);
			insert(target, div3, anchor);
			append(div3, h1);
			append(h1, t1);
			append(h1, t2);
			append(h1, ruby);
			append(ruby, rb);
			append(rb, t3);
			append(ruby, t4);
			append(ruby, rp0);
			append(ruby, t6);
			append(ruby, rt);
			append(rt, t7);
			append(ruby, t8);
			append(ruby, rp1);
			append(h1, t10);
			append(h1, t11);
			append(h1, t12);
			append(h1, t13);
			append(div3, t14);
			append(div3, p0);
			append(p0, t15);
			append(div3, t16);
			mount_component(images, div3, null);
			append(div3, t17);
			if_blocks[current_block_type_index].m(div3, null);
			append(div3, t18);
			append(div3, div0);
			append(div0, h2);
			append(h2, t19);
			append(div0, t20);
			append(div0, p1);
			append(p1, t21);
			append(div0, t22);
			if (if_block1) if_block1.m(div0, null);
			append(div3, t23);
			append(div3, div1);
			append(div1, h30);
			append(h30, img0);
			append(div1, t24);
			append(div1, p2);
			append(div1, t26);
			append(div1, a);
			append(a, t27);
			append(a, t28);
			append(a, t29);
			append(a, svg);
			append(svg, path);
			append(div3, t30);
			mount_component(cartin, div3, null);
			append(div3, t31);
			append(div3, div2);
			append(div2, h31);
			append(h31, img1);
			append(div2, t32);
			append(div2, table);
			append(table, tr0);
			append(tr0, th0);
			append(tr0, td0);
			append(td0, t34);
			append(table, t35);
			append(table, tr1);
			append(tr1, th1);
			append(tr1, td1);
			append(td1, t37);
			append(table, t38);
			append(table, tr2);
			append(tr2, th2);
			append(tr2, td2);
			append(td2, t40);
			append(table, t41);
			append(table, tr3);
			append(tr3, th3);
			append(tr3, td3);
			append(td3, t43);
			append(td3, t44);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*jewellery*/ 1) && t1_value !== (t1_value = /*jewellery*/ ctx[0].arrangeName + "")) set_data(t1, t1_value);
			if ((!current || dirty & /*jewellery*/ 1) && t3_value !== (t3_value = /*jewellery*/ ctx[0].arrangeName2 + "")) set_data(t3, t3_value);
			if ((!current || dirty & /*jewellery*/ 1) && t7_value !== (t7_value = /*jewellery*/ ctx[0].ruby + "")) set_data(t7, t7_value);
			if ((!current || dirty & /*jewellery*/ 1) && t11_value !== (t11_value = /*jewellery*/ ctx[0].designName + "")) set_data(t11, t11_value);
			if ((!current || dirty & /*jewellery*/ 1) && t13_value !== (t13_value = /*jewellery*/ ctx[0].typeName + "")) set_data(t13, t13_value);
			if ((!current || dirty & /*jewellery*/ 1) && t15_value !== (t15_value = /*jewellery*/ ctx[0].explanation + "")) set_data(t15, t15_value);
			const images_changes = {};
			if (dirty & /*jewellery*/ 1) images_changes.jewellery = /*jewellery*/ ctx[0];
			images.$set(images_changes);
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				} else {
					if_block0.p(ctx, dirty);
				}

				transition_in(if_block0, 1);
				if_block0.m(div3, t18);
			}

			if ((!current || dirty & /*jewellery*/ 1) && t19_value !== (t19_value = /*jewellery*/ ctx[0].postTitle + "")) set_data(t19, t19_value);
			if ((!current || dirty & /*jewellery, contentsPageNum*/ 3) && t21_value !== (t21_value = /*jewellery*/ ctx[0].contents[/*contentsPageNum*/ ctx[1]] + "")) set_data(t21, t21_value);

			if (/*jewellery*/ ctx[0].contents.length > 1) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (!current || dirty & /*jewellery*/ 1 && !src_url_equal(img0.src, img0_src_value = /*getBtoTitle*/ ctx[2](/*jewellery*/ ctx[0].assetsUrl, /*jewellery*/ ctx[0].typeID))) {
				attr(img0, "src", img0_src_value);
			}

			if (!current || dirty & /*jewellery*/ 1 && img0_alt_value !== (img0_alt_value = "この" + /*jewellery*/ ctx[0].typeName + "を、あなたの願いにあわせてカスタマイズできます。")) {
				attr(img0, "alt", img0_alt_value);
			}

			if ((!current || dirty & /*jewellery*/ 1) && t28_value !== (t28_value = /*jewellery*/ ctx[0].typeName + "")) set_data(t28, t28_value);

			if (!current || dirty & /*jewellery*/ 1 && a_href_value !== (a_href_value = /*jewellery*/ ctx[0].btoUrl)) {
				attr(a, "href", a_href_value);
			}

			if (!current || dirty & /*jewellery*/ 1 && div1_class_value !== (div1_class_value = "jewellery-to-ordermade page-type-" + /*jewellery*/ ctx[0].typeID + " svelte-1gwxeom")) {
				attr(div1, "class", div1_class_value);
			}

			if (!current || dirty & /*jewellery*/ 1) {
				set_style(div1, "background-image", "url(" + /*getCustomizeBG*/ ctx[3](/*jewellery*/ ctx[0].assetsUrl, /*jewellery*/ ctx[0].typeID) + ")");
			}

			const cartin_changes = {};
			if (dirty & /*jewellery*/ 1) cartin_changes.jewellery = /*jewellery*/ ctx[0];
			cartin.$set(cartin_changes);
			if ((!current || dirty & /*jewellery*/ 1) && t34_value !== (t34_value = /*jewellery*/ ctx[0].postTitle + "")) set_data(t34, t34_value);
			if ((!current || dirty & /*jewellery*/ 1) && t37_value !== (t37_value = /*jewellery*/ ctx[0].code + "")) set_data(t37, t37_value);
			if ((!current || dirty & /*jewellery*/ 1) && t40_value !== (t40_value = /*jewellery*/ ctx[0].arrangeName + "")) set_data(t40, t40_value);
			if ((!current || dirty & /*jewellery*/ 1) && t43_value !== (t43_value = /*jewellery*/ ctx[0].designName + "")) set_data(t43, t43_value);
		},
		i(local) {
			if (current) return;
			transition_in(images.$$.fragment, local);
			transition_in(if_block0);
			transition_in(cartin.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(images.$$.fragment, local);
			transition_out(if_block0);
			transition_out(cartin.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(link);
			if (detaching) detach(t0);
			if (detaching) detach(div3);
			destroy_component(images);
			if_blocks[current_block_type_index].d();
			if (if_block1) if_block1.d();
			destroy_component(cartin);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { jewellery } = $$props;
	let contentsPageNum = 0;

	const getTypeCode = typeID => {
		let ret = '';

		if ('1' === typeID) {
			ret = '';
		} else if ('2' === typeID) {
			ret = '_necklace';
		} else if ('3' === typeID) {
			ret = '_pierce';
		} else if ('4' === typeID) {
			ret = '_strap';
		} else if ('5' === typeID) {
			ret = '_ring';
		}

		return ret;
	};

	const getBtoTitle = (url, typeID) => {
		let ret = getTypeCode(typeID);
		return url + '/common/bg_h3_custombox' + ret + '.webp';
	};

	const getCustomizeBG = (url, typeID) => {
		let ret = getTypeCode(typeID);
		ret = '' === ret ? '_bracelet' : ret;
		return url + '/common/bg_itempage_custombox_p' + ret + '.webp';
	};

	const specTitle = jewellery.assetsUrl + '/common//h3_itempage_spec.webp';
	const componentBG = jewellery.assetsUrl + '/common/bg_post.webp';

	const click_handler = () => {
		$$invalidate(1, contentsPageNum--, contentsPageNum);
	};

	const click_handler_1 = () => {
		$$invalidate(1, contentsPageNum++, contentsPageNum);
	};

	$$self.$$set = $$props => {
		if ('jewellery' in $$props) $$invalidate(0, jewellery = $$props.jewellery);
	};

	return [
		jewellery,
		contentsPageNum,
		getBtoTitle,
		getCustomizeBG,
		specTitle,
		componentBG,
		click_handler,
		click_handler_1
	];
}

class LitJewelleryDetail extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { jewellery: 0 });
	}
}

export default LitJewelleryDetail;